<template>
<m-pageframe
    title="Home: Outshinery"
>
<v-container
    fluid
    style="padding-left: 15px; padding-right: 15px"
>

    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
    </v-text-field>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"

        v-on:click:row="onClickRow"
    >
    
        <template v-slot:item.time_create_date="{ item }">
            {{$rc.pretty(item.time_create,'date')}}
        </template>
    
    </v-data-table>

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');
export default {
    data() {
        return {
            full_text: null,
            results: [],

            headers: [
                { text: 'Organization', value: 'organization_label'},
                { text: 'Created', value: 'time_create_date'},
                { text: 'Assets Active', value: 'count_active'},
                { text: 'Assets Archived', value: 'count_archived'},
                { text: 'Assets Total', value: 'count_total'},
            ],
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/integrations/outshinery/list-organizations',
            
                'params' : {
                        'full_text': this.full_text,
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                    },
            
                'on_error': 'Unable to search outshinery organizations',
            });
        },

        onClickRow(item)
        {
            this.$router.push({
                'name': 'media-asset-edit-all-one-content-type',
                'params' : {
                    'organization_id': item.organization_id,
                    'content_type': 'outshinery',
                }
            });
        },
        
    },
}
</script>

<style lang="scss" scoped>
</style>